export default {
  brewery: 'alesong',
  info_url: 'http://landing.tavour.com/alesong/',
  title: {
    in_progress: '',
    success: 'You have joined the Alesong Bottle Club!',
    subtext: "Join Alesong's Quarterly Bottle Club",
  },
  review: {
    summary: [
      'You are joining the Alesong Bottle Club where you will receive 8 delicious beers quarterly.',
      'By signing up, your credit card will automatically be charged $156/quarter.',
      'You\'ll have the opportunity to "opt out" before your card is charged.',
      "You'll receive a notification when the box is charged and tracking info when it ships.",
      'Thank you!',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/alesong.js